/**
 * Mixin для axios-форм
 */

export const axiosForm = {
    props: {
        /**
         * @prop trans - локализация
         * @prop action - action адрес формы
         */
        trans: Object,
        action: String,
        cancel_route: String,
        method: String,
    },
    data() {
        return {
            isLoading: false,
            errors: {},
            needReload: true,
        }
    },
    methods: {
        clearValidation(e) {
            let target = e.target.name;

            if (this.errors[target]) {
                this.errors[e.target.name] = false;
            }
        },
        sendRequest(action, data, method, config) {
            let axiosParams = {
                method: method || this.method || 'post',
                url: action,
                data: data,
                headers: config || {},
            };

            if (this.preRequestHandler) {
                this.preRequestHandler();
            }

            axios(axiosParams)
                .then (response => {

                    sendGAEvent(this.okReport);

                    // Если в компоненте есть спец. метод для обработки ответа
                    if (this.postResultHandler) {
                        /*
                         * TODO: переименовать postResultHandler в requestResultHandler
                         *  здесь и во всех компонентах
                         */
                        this.postResultHandler(response);
                        return;
                    }

                    if (this.needReload) {
                        window.location.replace(response.request.responseURL);
                    }
                })
                .catch (error => {
                    if (!this.failReport) {
                        this.failReport = 'Неизвестная ошибка';
                    }

                    // Если в компоненте есть спец. метод для обработки ошибок
                    if (this.postErrorHandler) {
                        /*
                         * TODO: переименовать postErrorHandler в requestErrorHandler
                         *  здесь и во всех компонентах
                         */
                        this.postErrorHandler(error);
                        sendGAError(this.failReport);
                        return;
                    }

                    let errorStatus = false,
                        errorUrl = this.action;

                    if (error.response) {
                        errorStatus = error.response.status;
                        errorUrl = error.response.request.responseURL;
                    }

                    // Если ошибка связана с валидацией(422) или превышением лимита попыток(429)
                    if (errorStatus === 422 || errorStatus === 429) {
                        let errorList = error.response.data.errors;

                        for (let array in errorList) {
                            let arrayIsEmpty = !errorList[array].length;

                            if (!arrayIsEmpty) {
                                errorList[array] = errorList[array][0];
                            }
                        }

                        this.errors = errorList;

                    // Если непредвиденная ошибка
                    } else {
                        let isFormError = errorUrl.includes(this.action);

                        // Если ошибка текущей формы - покажем сообщение
                        if (isFormError || !this.needReload) {
                            Vue.set(this.errors, 'unexpected', this.trans.msg.unexpected_error);
                        } else {
                            // Если ошибка не связана с авторизацией - направим на страницу ошибки
                            window.location.replace(errorUrl);
                        }
                    }

                    sendGAError(this.failReport + ' (' + errorStatus + ')');
                })
                .finally (() => this.isLoading = false);
        },
        submit(event, action, method) {
            action = action || this.action;

            this.errors = {};
            this.isLoading = true;

            this.sendRequest(action, this.form, method);
        }
    }
};
